import React from "react";
import { Box } from "@mui/material";

import FirstDataSection from "../components/smartSupplyChain/FirstDataSection";
import OurApproach from "../components/smartSupplyChain/OurApproach";
import BackgroundEffects from "../components/commonComponents/BackgroundEffects";
import HeroBanner from "../components/commonComponents/HeroBanner";
import CommonCTA from "../components/commonComponents/CommonCTA";
import SEO from "../components/commonComponents/SEO";

export default function SmartSupplyChainPage() {
  return (
    <>
      <SEO
        title="Smart Supply Chain Solutions in Saudi Arabia | ZENCON"
        description="ZENCON provides smart supply chain solutions to improve real-time visibility, optimize inventory, streamline procurement, enhance logistics, automate operations, and deliver intelligent supply chain transformation in Saudi Arabia."
        keywords="smart supply chain solutions, supply chain automation, inventory optimization, procurement solutions, logistics management, supply chain analytics, enterprise integration, SAP supply chain Saudi Arabia"
        url="https://www.zencon-sa.com/smart-supply-chain-page"
        image="https://www.zencon-sa.com/images/default-image.png"
      />
      <HeroBanner title={"Smart SAP"} subtitle={""} />
      <Box
        sx={{
          minHeight: "100vh",
          position: "relative",
          overflow: "hidden",
          background:
            "linear-gradient(135deg, #f7fbff 0%, #eef7f4 45%, #f8fbff 100%)",
        }}
      >
        <BackgroundEffects />
        <FirstDataSection />
        <OurApproach />
        <CommonCTA />
      </Box>
    </>
  );
}
